import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Hashtag18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.74256 2.10604C7.80114 1.69599 7.51621 1.31609 7.10616 1.25751C6.69611 1.19893 6.31621 1.48386 6.25763 1.89391L5.77819 5.25H3C2.58579 5.25 2.25 5.58579 2.25 6C2.25 6.41421 2.58579 6.75 3 6.75H5.56391L4.92105 11.25H2C1.58579 11.25 1.25 11.5858 1.25 12C1.25 12.4142 1.58579 12.75 2 12.75H4.70676L4.25763 15.8939C4.19905 16.304 4.48398 16.6839 4.89403 16.7424C5.30408 16.801 5.68398 16.5161 5.74256 16.106L6.22199 12.75H10.7068L10.2576 15.8939C10.1991 16.304 10.484 16.6839 10.894 16.7424C11.3041 16.801 11.684 16.5161 11.7426 16.106L12.222 12.75H15C15.4142 12.75 15.75 12.4142 15.75 12C15.75 11.5858 15.4142 11.25 15 11.25H12.4363L13.0791 6.75H16C16.4142 6.75 16.75 6.41421 16.75 6C16.75 5.58579 16.4142 5.25 16 5.25H13.2934L13.7426 2.10604C13.8011 1.69599 13.5162 1.31609 13.1062 1.25751C12.6961 1.19893 12.3162 1.48386 12.2576 1.89391L11.7782 5.25H7.29342L7.74256 2.10604ZM10.921 11.25L11.5639 6.75H7.07913L6.43628 11.25H10.921Z'
      fill='currentColor'
    />
  </Svg>
);

Hashtag18.displayName = 'Hashtag18';
export default Hashtag18;
